(function() {
	'use strict';
	var
		detectedPlatform = avastGlobals.detect.os.name.toLowerCase() === 'windows' ? 'pc' : avastGlobals.detect.os.name.toLowerCase(),
		collapseCompBox = document.querySelectorAll('.compare-box-btn .collapse-btn'),
		collapseCompTable = document.querySelector('#compare-table-btn .collapse-btn'),

		// When clicked on button, page scrolls to button's target
		scrollToTarget = function(e){
			document.querySelector(e.currentTarget.getAttribute('data-bs-target')).scrollIntoView();
		},

		// Makes active panel/toggler based on platform detection
		setActivePanel = function(platform){
			try {
				var
					togglers = document.querySelectorAll('.toggler-item'),
					activeToggler = document.querySelector('[aria-controls="content_'+platform+'"]'),
					panels = document.querySelectorAll('.tab-panel'),
					activePanel = document.getElementById('content_'+platform);

				// reset togglers
				togglers.forEach(function(toggler){
					toggler.classList.remove("active");
					toggler.setAttribute('aria-selected', 'false');
				});

				// reset panels
				panels.forEach(function(panel){
					panel.classList.remove("show", "active");
				});

				// set toggler and panel active by detected platform
				activeToggler.classList.add("active");
				activeToggler.setAttribute('aria-selected', 'true');
				activePanel.classList.add("show", "active");
				
			} catch (error) {
				// singe data layer error tracking
				if (typeof sdl !== 'undefined') {
					console.error(error);
					sdl.push({
						system: {
							error: {
								type: error.name,
								message: error.message,
							}
						},
						event: 'system.error'
					})
				}
			}
		},
		
		// Observer to monitor the status of the table and update opening button's icon accordingly
		observer = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {
				if (mutation.type === "attributes" && mutation.attributeName === "aria-expanded") {
					var
						attrVal = mutation.target.getAttribute(mutation.attributeName),
						iconEntity = mutation.target.querySelector('[data-cmp-name="icon"]');
	
					if (attrVal === 'true') {
						//table is expanded
						iconEntity.classList.remove("icon-filter");
						iconEntity.classList.add("icon-cross");

						// remove toggle attribute from links in Compare boxes thus disable their collapse functionality
						collapseCompBox.forEach(function(button){
							button.removeAttribute("data-bs-toggle");
						});

					} else {
						//table is collapsed
						iconEntity.classList.add("icon-filter");
						iconEntity.classList.remove("icon-cross");

						// add toggle attribute to links in Compare boxes thus enable their collapse functionality
						collapseCompBox.forEach(function(button){
							button.dataset.bsToggle = "collapse";
						});
					}
				}
			})
		}),

		// Hide overlapping table sticky headers
		waypoints = avm.require('avast.web.waypoints'),
		tableHeaders = document.querySelectorAll('.tr.table-header-tr.simple'),
		hideHeader = function(header, boolean) {
			if (boolean) {
				header.classList.add('unsticked');
			} else {
				header.classList.remove('unsticked');
			}
		},

		// Check el visibility is the DOM
		isVisible = function(el) {
			return (el.offsetParent != null);
		},
		
		// Re-detect tooltips for proper functionality on vue priceboxes
		tooltipInit = function(){
			document.querySelectorAll(".pricebox [data-bs-toggle='tooltip']").forEach(function(tooltip){
				var bsnTip = new BSN.Tooltip(tooltip);
			});
		};
		

	// Find next header element after each header -> next header is a waypoint where each header should not be sticky anymore
	tableHeaders.forEach(function(header) {
		var
			nextEl = header.nextElementSibling,
			nextHeader;
		
		// iterate trough siblings to find a next header
		while (nextEl) {
			if (nextEl.classList.contains('table-header-tr')) {
				nextHeader = nextEl;
				break;
			}
			nextEl = nextEl.nextElementSibling;
		}

		// event listeners assignment only if waypoint element exists
		if (nextHeader) {
			window.addEventListener('scroll', function () {
				
				// if table and both header and its waypoint header are visible, check the waypoint position
				if (document.getElementById('compare-table-collapse').classList.contains('show') && isVisible(header) && isVisible(nextHeader)) {
					if (waypoints(nextHeader, 20, null, true)) {
						hideHeader(header, true);
					} else  {
						hideHeader(header, false);
					}
				}
			});
		}
	});

	// Set active panel on comparison table
	setActivePanel(detectedPlatform);

	// Listeners for collapse buttons in Compare Boxes
	collapseCompBox.forEach(function(button){
		button.addEventListener("click", scrollToTarget);
	});

	collapseCompTable.addEventListener("click", scrollToTarget);

	// Observer - pass the target node, as well as the observer options
	observer.observe(collapseCompTable, {attributes: true});


	// listen to pricebox change and init the tooltip on #mac buy buttons
	window.addEventListener("pricebox-updated", tooltipInit);

})();


//carousel configuration
var testimonials = tns({
	"container": ".avast-one-testimonials",
	"controlsContainer": ".avast-one-testimonials-controls",
	"preventScrollOnTouch": "force",
	"controlsPosition": "bottom",
	"navPosition": "bottom",
	"gutter": 24,
	"slideBy": "page",
	"responsive": {
		"992": {
			"gutter": 32
		}
	}
});
// Create a slide counter bellow the Carousel
avm.require('avast.web.slideCounter')(testimonials);
